import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import { openWhatsApp } from "@/lib/whatsapp";

export default function NotFoundPage() {
  return (
    <section className="flex min-h-[70vh] items-center justify-center bg-white px-4 pt-24" data-testid="not-found-page">
      <div className="max-w-lg text-center">
        <span className="font-heading text-7xl font-bold text-[#5B2C91]">404</span>
        <h1 className="font-heading mt-4 text-3xl sm:text-4xl font-medium tracking-tight text-[#1F152E]">
          Pagina non trovata
        </h1>
        <p className="mt-4 text-base leading-relaxed text-[#4A4059]">
          La pagina che cerchi non esiste o è stata spostata. Torna alla home oppure scrivici su
          WhatsApp per una visita.
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex w-full sm:w-auto items-center justify-center gap-2 rounded-full bg-[#5B2C91] px-7 py-4 text-base font-semibold text-white shadow-[0_16px_40px_rgba(91,44,145,0.28)] hover:bg-[#4A2277] hover:-translate-y-0.5 transition-[transform,background-color] duration-200"
            data-testid="notfound-home-btn"
          >
            <Home className="h-5 w-5" />
            Torna alla home
          </Link>
          <button
            onClick={() => openWhatsApp()}
            className="inline-flex w-full sm:w-auto items-center justify-center gap-2 rounded-full bg-white px-7 py-4 text-base font-semibold text-[#5B2C91] ring-1 ring-[#5B2C91]/20 hover:ring-[#5B2C91]/40 transition-[box-shadow] duration-200"
            data-testid="notfound-whatsapp-btn"
          >
            <FaWhatsapp className="h-5 w-5" />
            Richiedi una visita
          </button>
        </div>
      </div>
    </section>
  );
}
